import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { InterceptorAuthProvider } from '../../../../../providers/interceptor-auth/interceptor-auth';

@Component({
  selector: 'header-popover',
  templateUrl: 'header-popover.html'
})
export class HeaderPopoverComponent {

  firstName: string;
  lastName: string;
  userRole: string;
  clientPlans: any;
  tokenResults: any;

  userLinks: any = [
    { title: 'Apps', icon: 'apps',  link: 'AppsPage', display: false },
    { title: 'Signout', icon: 'log-out',  link: 'LoginPage', display: true }
  ]

  constructor(
    public authService: InterceptorAuthProvider, 
    public navCtrl: NavController, 
    public navParams: NavParams,
  ){}
  
  async ngOnInit(){
    //this.authService.getUser().subscribe(user => {
      this.tokenResults = this.authService.getLinkTokenResult()
      if(this.tokenResults != null){
        this.firstName = this.tokenResults.given_name
        this.lastName = this.tokenResults.family_name
        this.userRole = this.tokenResults.UserRole
      }
      
      this.clientPlans = this.navParams.data.cp

      if(this.userRole == 'Admin' && Array.isArray(this.tokenResults.Application) == true) {
        this.userLinks[0].display = true
      }
    //})
    
  }

  selectPage(event){
    if(event == 'LoginPage'){
      this.authService.logout()
    }
    if (event == 'AppsPage') {
      this.authService.returnToLink();
    } else {
      this.navCtrl.push(event, {}, {
        animate: false
      })
    }  
  } 

}



// WEBPACK FOOTER //
// ./src/components/shared/layout/app-header/header-popover/header-popover.ts